<template>
  <div class="bg-body rounded p-5 mb-5">
    <div class="row">
        <div class="col-md-6">
            <h4 class="fw-bold text-gray-900 mb-0 ms-lg-4 mb-5 mb-md-0">
                {{ this.$route.meta.title || 'Страница' }}
                <span class="mt-2 d-block fw-normal fs-8 text-muted">Выгрузка отчетов</span>
            </h4>
        </div>
        <div class="col-md-6">
            <div class="d-flex justify-content-end">
                <div v-if="!loadingInit" class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3 mt-1">
                    <div class="btn-group" role="group" aria-label="Export mode">
                        <button
                        type="button"
                        class="btn btn-sm"
                        :class="exportType === 'orders' ? 'btn-success' : 'btn-light'"
                        @click="exportType = 'orders'"
                        >
                        Заказы
                        </button>
                        <button
                        type="button"
                        class="btn btn-sm"
                        :class="exportType === 'payments' ? 'btn-success' : 'btn-light'"
                        @click="exportType = 'payments'"
                        >
                        Пополнения
                        </button>
                        <button
                        type="button"
                        class="btn btn-sm"
                        :class="exportType === 'tickets' ? 'btn-success' : 'btn-light'"
                        @click="exportType = 'tickets'"
                        >
                        Абонименты
                        </button>
                        <button
                        type="button"
                        class="btn btn-sm"
                        :class="exportType === 'customers' ? 'btn-success' : 'btn-light'"
                        @click="exportType = 'customers'"
                        >
                        Клиенты
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>

  <div class="bg-body rounded p-5 mb-5">
    <loader v-if="loadingInit" :height="20" />

    <div v-if="!loadingInit" class="row">
      <div v-if="exportType !== 'customers'" class="col-lg-2 mb-5 mb-lg-0">
        <date-field
          v-model="form.fromDate"
          :required="true"
          id="reportFilter.fromDate"
          name="reportFilter.fromDate"
          placeholder="Дата начало"
          mb="5"
        />
      </div>
      <div v-if="exportType !== 'customers'" class="col-lg-2 mb-5 mb-lg-0">
        <date-field
          v-model="form.toDate"
          :required="true"
          id="reportFilter.toDate"
          name="reportFilter.toDate"
          placeholder="Дата конца"
          mb="5"
        />
      </div>
      <div v-if="exportType === 'orders'" class="col-lg-3 mb-5 mb-lg-0">
        <input-field
          v-model="form.userId"
          id="reportFilter.userId"
          name="reportFilter.userId"
          placeholder="ID Клиента"
          type="text"
          mb="5"
        />
      </div>
      <div v-if="exportType === 'orders'" class="col-lg-2 mb-5 mb-lg-0">
        <div class="custom-select dynamic w-100">
          <label for="reportFilter.status" class="required">Статус</label>
          <v-select
            v-model="form.status"
            input-id="reportFilter.status"
            :options="statuses"
            :disabled="!statuses.length"
            :reduce="item => item.code"
            :required="true"
            placeholder="Выберите..."
            class="bg-gray-100 form rounded"
            label="descr"
          />
        </div>
      </div>
      <div v-if="exportType === 'orders'" class="col-lg-3 mb-5 mb-lg-0">
        <div class="custom-select dynamic w-100">
          <label v-if="stations" for="reportFilter.pointCode" class="required">Локация</label>
          <v-select
            v-if="stations"
            :loading="!stations"
            v-model="form.pointCode"
            input-id="reportFilter.pointCode"
            :options="stations"
            :disabled="!stations.length"
            :reduce="item => item.id"
            :required="true"
            placeholder="Выберите..."
            class="bg-gray-100 form rounded"
            label="label"
          />
        </div>
      </div>
    </div>

    <div v-if="!loadingInit" class="d-flex justify-content-between flex-column flex-lg-row">
      <div @click="reset" class="btn btn-sm btn-light-danger me-2">Сбросить</div>
      <button
          type="button"
          class="btn btn-sm btn-warning"
          :disabled="loadingExport || !canExport"
          @click="exportFile"
        >
          {{ loadingExport ? 'Подождите...' : 'Выгрузить' }}
        </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { notify } from '@kyvg/vue3-notification'
import Loader from '@/components/Loader'
import DateField from '@/components/Fields/DateField'
import vSelect from 'vue-select'
import InputField from '@/components/Fields/InputField.vue'

export default {
  name: 'Reports',
  components: { InputField, vSelect, DateField, Loader },
  data() {
    return {
      statuses: [],
      stations: null,
      loadingInit: false,
      loadingExport: false,
      exportType: 'orders', // 'orders' | 'payments' | 'tickets' | 'customers'
      form: {
        fromDate: '',
        toDate: '',
        status: null,
        pointCode: null,
        userId: null,
      },
    }
  },
  computed: {
    canExport() {
      if (this.exportType === 'customers') return true
      return Boolean(this.form.fromDate && this.form.toDate)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loadingInit = true
      Promise.all([this.getStatusesDic(), this.getStations()])
        .finally(() => {
          this.loadingInit = false
        })
    },
    getStations() {
      return axios.get('partner-branching-service/api/v1/partners/points', {
        params: { page: 0, size: 500 }
      })
        .then(res => {
          if (Array.isArray(res.data?.content)) {
            this.stations = res.data.content
          } else {
            notify({
              duration: 7000,
              type: 'error',
              speed: 1000,
              title: 'Ошибка',
              text: 'Не удалось загрузить локации',
            })
          }
        })
        .catch(error => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: error?.response?.data?.errorDescription ?? error.message,
          })
        })
    },
    getStatusesDic() {
      return axios.get('order-service/api/v1/admin/statuses/esp')
        .then(res => {
          if (Array.isArray(res.data) && res.data.length > 0) {
            this.statuses = res.data
          } else {
            notify({
              duration: 7000,
              type: 'error',
              speed: 1000,
              title: 'Ошибка',
              text: 'Статусы не найдены',
            })
          }
        })
        .catch(error => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: error?.response?.data?.errorDescription ?? error.message,
          })
        })
    },
    toUnix(dateStr, isEnd = false) {
      const date = new Date(`${dateStr}T00:00:00+05:00`)
      if (isEnd) {
        date.setDate(date.getDate() + 1)
      }
      return date.getTime()
    },
    exportFile() {
      if (!this.canExport) return
      this.loadingExport = true

      let params = null
      if (this.exportType === 'customers') {
        // Для отчёта "Клиенты" даты не передаём
        params = undefined
      } else if (this.exportType === 'tickets') {
        // ВАЖНО: API принимает даты строкой YYYY-MM-DD
        params = {
          fromDate: this.form.fromDate,
          toDate: this.form.toDate,
        }
      } else if (this.exportType === 'payments') {
        params = {
          fromDate: this.toUnix(this.form.fromDate),
          toDate: this.toUnix(this.form.toDate, true),
        }
      } else {
        params = {
          fromDate: this.toUnix(this.form.fromDate),
          toDate: this.toUnix(this.form.toDate, true),
          pointCode: this.form.pointCode,
          status: this.form.status,
          userId: this.form.userId,
        }
      }

      const url =
        this.exportType === 'customers'
          ? '/api/v1/billing/issuer/customers/export'
          : this.exportType === 'tickets'
          ? 'order-service/api/v1/admin/orders/tickets/download'
          : this.exportType === 'payments'
            ? 'order-service/api/v1/admin/orders/payments/download'
            : 'order-service/api/v2/admin/orders/esp/download'

      const fileName =
        this.exportType === 'customers'
          ? 'customers.xlsx'
          : this.exportType === 'tickets'
          ? 'tickets.xlsx'
          : this.exportType === 'payments'
            ? 'replenishment.xlsx'
            : 'orders.xlsx'

      const config = {
        responseType: 'blob',
        ...(params ? { params } : {})
      }

      axios.get(url, config)
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: error?.response?.data?.errorDescription ?? error.message,
          })
        })
        .finally(() => {
          this.loadingExport = false
        })
    },
    reset() {
      this.form = {
        fromDate: '',
        toDate: '',
        status: null,
        pointCode: null,
        userId: null,
      }
    }
  }
}
</script>

<style scoped></style>
